"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.isfunction"));

var _lodash3 = _interopRequireDefault(require("lodash.isstring"));

var _lodash4 = _interopRequireDefault(require("lodash.set"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var normalizeSchema = function normalizeSchema(value) {
  return _typeof(value) === 'object' ? value : {
    value: value
  };
};

function setIfDefined(target, key, value) {
  if (value !== undefined) {
    (0, _lodash4.default)(target, key, value);
  }

  return target;
}

function _default(schema, data) {
  return Object.keys(schema).filter(function (key) {
    return (0, _lodash2.default)(schema[key].applicable) ? schema[key].applicable(data) : true;
  }).reduce(function (output, key) {
    var _normalizeSchema = normalizeSchema(schema[key]),
        whitelist = _normalizeSchema.whitelist,
        value = _normalizeSchema.value;

    if ((0, _lodash2.default)(value)) {
      return setIfDefined(output, key, value(data));
    }

    if ((0, _lodash3.default)(value)) {
      if (whitelist) {
        return setIfDefined(output, key, (0, _lodash.default)(whitelist, (0, _lodash.default)(data, value)));
      }

      return setIfDefined(output, key, (0, _lodash.default)(data, value));
    }

    return output;
  }, {});
}